/**
 * TODO: TypeScript return type for this function
 *
 * Returns an array of Elements which satisfy the query that are direct
 * children of the Element. Needed since ":scope" CSS selector is not supported
 * by the hydration engine.
 *
 * @param el the Element to search
 * @param query querySelector query
 * @returns Array of Elements which are direct children of el
 */
const directChildren = (el: HTMLElement, query: string) => {
  const results = Array.from(el.querySelectorAll(query));
  const children = Array.from(el.children);

  return results.reduce((arr, child) => {
    if (children.includes(child)) {
      arr.push(child);
    }
    return arr;
  }, []);
};

export default directChildren;
